import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '../globals';
declare var $, unescape, PerfectScrollbar, escape, AmCharts, swal: any;

@Component({
  selector: 'app-feedback-score',
  templateUrl: './feedback-score.component.html',
  styleUrls: ['./feedback-score.component.css']
})
export class FeedbackScoreComponent implements OnInit {
  rate1;
  rate2;
  rate3;
  rate4;
  rate5;
  rate6;
  rate7;
  rate8;
  rate9;
  Delivering;
  Receiving;

  FirstName;
  LastName;
  user1Entity;
  user2Entity;
  user3Entity;
  mavg;
  MaltiRater;
  ParentId;

  constructor(public globals: Globals, private router: Router) { }

  ngOnInit() {
    this.MaltiRater = localStorage.getItem('MaltiRater');
    this.ParentId = localStorage.getItem('ParentId');
    if (this.ParentId == 0) {
      var check = true;
    } else {
      var check = false;
    }
    if (this.MaltiRater == 1) {
      var btn_title = 'Do you want to rate yourself?';
      var btn_text = 'Click on <b>Rate yourself</b> button in the upper right hand corner';
    } else {
      var btn_title = 'Do you want to rate other individuals (Multi-Rater/360 Assessment)?';
      var btn_text = 'Click on <b>Multi-Rater Feedback</b> button in the upper right hand corner to rate another individual';
    }
    setTimeout(function () {
      if (check) {
        $('#tabs').tabCollapse();
        swal({
          type: 'info',
          title: btn_title,
          html: btn_text,
          closeOnClickOutside: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          confirmButtonText: "Ok",
        },
          function () {

          });
      }
    }, 500);

    this.rate1 = localStorage.getItem('rate1');
    if (this.rate1 > 0 || this.rate1 == 0) {
      this.globals.pageTitle = '- Feedback Score';
      this.rate2 = localStorage.getItem('rate2');
      this.rate3 = localStorage.getItem('rate3');
      this.rate4 = localStorage.getItem('rate4');
      this.rate5 = localStorage.getItem('rate5');
      this.rate6 = localStorage.getItem('rate6');
      this.rate7 = localStorage.getItem('rate7');
      this.rate8 = localStorage.getItem('rate8');
      this.rate9 = localStorage.getItem('rate9');
      this.Delivering = localStorage.getItem('Delivering');
      this.Receiving = localStorage.getItem('Receiving');


      let Delivering = parseFloat(this.Delivering).toFixed(1);
      let Receiving = parseFloat(this.Receiving).toFixed(1);
      let rate1 = parseFloat(this.rate1).toFixed(1);
      let rate2 = parseFloat(this.rate2).toFixed(1);
      let rate3 = parseFloat(this.rate3).toFixed(1);
      let rate4 = parseFloat(this.rate4).toFixed(1);
      let rate5 = parseFloat(this.rate5).toFixed(1);
      let rate6 = parseFloat(this.rate6).toFixed(1);
      let rate7 = parseFloat(this.rate7).toFixed(1);
      let rate8 = parseFloat(this.rate8).toFixed(1);
      let rate9 = parseFloat(this.rate9).toFixed(1);
      this.rate1 = (3.1).toFixed(1);
      this.rate2 = (2.0).toFixed(1);
      this.rate3 = (4.0).toFixed(1);
      this.rate4 = (2.6).toFixed(1);
      this.rate5 = (1.7).toFixed(1);
      this.rate6 = (0.2).toFixed(1);
      this.rate7 = (3.4).toFixed(1);
      this.rate8 = (4.0).toFixed(1);
      this.rate9 = (2.9).toFixed(1);

      this.FirstName = localStorage.getItem('FirstName');
      this.LastName = localStorage.getItem('LastName');

      this.user1Entity = {};
      this.user1Entity.rate1 = rate1;
      this.user1Entity.rate2 = rate2;
      this.user1Entity.rate3 = rate3;
      this.user1Entity.rate4 = rate4;
      this.user1Entity.rate5 = rate5;
      this.user1Entity.rate6 = rate6;
      this.user1Entity.rate7 = rate7;
      this.user1Entity.rate8 = rate8;
      this.user1Entity.rate9 = rate9;

      var currentYear = (new Date()).getFullYear();
      var month = ("0" + ((new Date()).getMonth() + 1)).slice(-2);
      var day = (new Date()).getDate();
      var todayDate = month + '/' + day + '/' + currentYear;
      $("#today_date").html(todayDate);
      $("#footer_year").html(currentYear);

      $('.delivering_circle').circleProgress({
        value: this.Delivering / 4,
        size: 200.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#222'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + Delivering + '</span> Overall Average<br>Score');
      });
      $('.receiving_circle').circleProgress({
        value: this.Receiving / 4,
        size: 200.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#222'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + Receiving + '</span> Overall Average<br>Score');
      });

      $('#Opportunistic_circle').circleProgress({
        value: this.user1Entity.rate1 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate1 + '</span>');
      });
      $('#Empathetic_circle').circleProgress({
        value: this.user1Entity.rate2 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate2 + '</span>');
      });
      $('#Progressive_circle').circleProgress({
        value: this.user1Entity.rate3 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate3 + '</span>');
      });
      $('#Communication_circle').circleProgress({
        value: this.user1Entity.rate4 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate4 + '</span>');
      });
      $('#Regulation_circle').circleProgress({
        value: this.user1Entity.rate5 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate5 + '</span>');
      });
      $('#Reactive_circle').circleProgress({
        value: this.user1Entity.rate6 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate6 + '</span>');
      });
      $('#Contingent_circle').circleProgress({
        value: this.user1Entity.rate7 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate7 + '</span>');
      });
      $('#Solicitation_circle').circleProgress({
        value: this.user1Entity.rate8 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate8 + '</span>');
      });
      $('#Evidential_circle').circleProgress({
        value: this.user1Entity.rate9 / 4,
        size: 120.0,
        emptyFill: '#ccc',
        fill: { gradient: ['#000', '#333'] }
      }).on('circle-animation-progress', function (event, progress) {
        $(this).find('strong').html('<span>' + rate9 + '</span>');
      });

      this.user2Entity = {};
      this.user2Entity.rate1 = (1.7).toFixed(1);
      this.user2Entity.rate2 = (3.8).toFixed(1);
      this.user2Entity.rate3 = (2.5).toFixed(1);
      this.user2Entity.rate4 = (4.0).toFixed(1);
      this.user2Entity.rate5 = (3.2).toFixed(1);
      this.user2Entity.rate6 = (1.0).toFixed(1);
      this.user2Entity.rate7 = (2.2).toFixed(1);
      this.user2Entity.rate8 = (3.5).toFixed(1);
      this.user2Entity.rate9 = (2.6).toFixed(1);

      this.user3Entity = {};
      this.user3Entity.rate1 = (4.0).toFixed(1);
      this.user3Entity.rate2 = (2.1).toFixed(1);
      this.user3Entity.rate3 = (4.3).toFixed(1);
      this.user3Entity.rate4 = (3.0).toFixed(1);
      this.user3Entity.rate5 = (1.3).toFixed(1);
      this.user3Entity.rate6 = (0.9).toFixed(1);
      this.user3Entity.rate7 = (2.0).toFixed(1);
      this.user3Entity.rate8 = (3.1).toFixed(1);
      this.user3Entity.rate9 = (4.0).toFixed(1);

      this.mavg = {};
      this.mavg.rate1 = ((+this.user1Entity.rate1 + +this.user2Entity.rate1 + +this.user3Entity.rate1) / 3).toFixed(1);
      this.mavg.rate2 = ((+this.user1Entity.rate2 + +this.user2Entity.rate2 + +this.user3Entity.rate2) / 3).toFixed(1);
      this.mavg.rate3 = ((+this.user1Entity.rate3 + +this.user2Entity.rate3 + +this.user3Entity.rate3) / 3).toFixed(1);
      this.mavg.rate4 = ((+this.user1Entity.rate4 + +this.user2Entity.rate4 + +this.user3Entity.rate4) / 3).toFixed(1);
      this.mavg.rate5 = ((+this.user1Entity.rate5 + +this.user2Entity.rate5 + +this.user3Entity.rate5) / 3).toFixed(1);
      this.mavg.rate6 = ((+this.user1Entity.rate6 + +this.user2Entity.rate6 + +this.user3Entity.rate6) / 3).toFixed(1);
      this.mavg.rate7 = ((+this.user1Entity.rate7 + +this.user2Entity.rate7 + +this.user3Entity.rate7) / 3).toFixed(1);
      this.mavg.rate8 = ((+this.user1Entity.rate8 + +this.user2Entity.rate8 + +this.user3Entity.rate8) / 3).toFixed(1);
      this.mavg.rate9 = ((+this.user1Entity.rate9 + +this.user2Entity.rate9 + +this.user3Entity.rate9) / 3).toFixed(1);
      this.mavg.Receiving = ((+this.mavg.rate5 + +this.mavg.rate6 + +this.mavg.rate7 + +this.mavg.rate8 + +this.mavg.rate9) / 5).toFixed(1);
      this.mavg.Delivering = ((+this.mavg.rate1 + +this.mavg.rate2 + +this.mavg.rate3 + +this.mavg.rate4) / 4).toFixed(1);


      //FEEDBACK_REPORT_CHART
      var chart = AmCharts.makeChart("feedbackreport_chart", {
        "type": "serial",
        "theme": "none",
        "precision": 2,
        "valueAxes": [{
          "id": "v1",
          "title": "Score",
          "position": "left",
          "autoGridCount": false,
          "minimum": 0,
          "maximum": 5
        }],
        "graphs": [{
          "id": "g3",
          "valueAxis": "v1",
          "lineColor": "#d0d0d0",
          "fillColors": "#d0d0d0",
          "fillAlphas": 1,
          "type": "column",
          "title": "Raters Average",
          "valueField": "sales2",
          "clustered": false,
          "columnWidth": 0.5,
          "precision": 1,
          "legendValueText": "[[value]]",
          "balloonText": "Global Average<br /><b style='font-size: 130%'>[[sales1]]</b><br>Raters Average<br /><b style='font-size: 130%'>[[value]]</b><br>Rita’s Self Score" + "<br /><b style='font-size: 130%'>[[market1]]</b>"
        }, {
          "id": "g4",
          "valueAxis": "v1",
          "lineColor": "#808080",
          "fillColors": "#808080",
          "fillAlphas": 1,
          "type": "column",
          "title": "Global Average",
          "valueField": "sales1",
          "clustered": false,
          "columnWidth": 0.3,
          "precision": 1,
          "legendValueText": "[[value]]",
          "balloonText": ""
        }, {
          "id": "g1",
          "valueAxis": "v2",
          "bullet": "round",
          "bulletBorderAlpha": 1,
          "bulletColor": "#ffffff",
          "bulletSize": 5,
          "hideBulletsCount": 50,
          "lineThickness": 2,
          "lineColor": "#b01116",
          "type": "smoothedLine",
          "title": "Rita’s Self Score",
          "dashLength": 5,
          "precision": 1,
          "useLineColorForBulletBorder": true,
          "valueField": "market1",
          "balloonText": ""
        },
          // {
          // "id": "g2",
          // "valueAxis": "v2",
          // "bullet": "round",
          // "bulletBorderAlpha": 1,
          // "bulletColor": "#FFFFFF",
          // "bulletSize": 5,
          // "hideBulletsCount": 50,
          // "lineThickness": 2,
          // "lineColor": "#000000",
          // "type": "smoothedLine",
          // "dashLength": 5,
          // "title": "Andre",
          // "useLineColorForBulletBorder": true,
          // "valueField": "market2",
          // "balloonText": "Andre<br /><b style='font-size: 130%'>[[value]]</b>"
          // },
          // {
          // "id": "g5",
          // "valueAxis": "v2",
          // "bullet": "round",
          // "bulletBorderAlpha": 1,
          // "bulletColor": "#FFFFFF",
          // "bulletSize": 5,
          // "hideBulletsCount": 50,
          // "lineThickness": 2,
          // "lineColor": "#000000",
          // "type": "smoothedLine",
          // "title": "Rita",
          // "useLineColorForBulletBorder": true,
          // "valueField": "market3",
          // "balloonText": "Rita<br /><b style='font-size: 130%'>[[value]]</b>"
          // }, {
          // "id": "g6",
          // "valueAxis": "v2",
          // "bullet": "round",
          // "bulletBorderAlpha": 1,
          // "bulletColor": "#FFFFFF",
          // "bulletSize": 5,
          // "hideBulletsCount": 50,
          // "lineThickness": 2,
          // "lineColor": "#b01116",
          // "type": "smoothedLine",
          // "dashLength": 5,
          // "title": "Randy",
          // "useLineColorForBulletBorder": true,
          // "valueField": "market4",
          // "balloonText": "Randy<br /><b style='font-size: 130%'>[[value]]</b>"
          // }
        ],
        "chartCursor": {
          "pan": true,
          "valueLineEnabled": true,
          "cursorAlpha": 0,
          "valueLineAlpha": 0.2
        },
        "categoryField": "title",
        "categoryAxis": {
          "dashLength": 1,
          "title": "",
          "position": "bottom",
          "minorGridEnabled": true,
          "autoWrap": true
        },
        "legend": {
          "useGraphSettings": true,
          "position": "top",
          "valueAlign": "left",
          "maxColumns": 3,
        },
        "balloon": {
          "borderThickness": 1,
          "shadowAlpha": 0,
        },
        "export": {
          "enabled": true
        },
        "dataProvider": [
          {
            "title": "Opportunistic Coaching",
            "market1": this.rate1,
            "market2": this.user1Entity.rate1,
            "market3": this.user2Entity.rate1,
            "market4": this.user3Entity.rate1,
            "sales1": (3.2).toFixed(1),
            "sales2": this.mavg.rate1
          }, {
            "title": "Empathetic",
            "market1": this.rate2,
            "market2": this.user1Entity.rate2,
            "market3": this.user2Entity.rate2,
            "market4": this.user3Entity.rate2,
            "sales1": (2.9).toFixed(1),
            "sales2": this.mavg.rate2
          }, {
            "title": "Progressive",
            "market1": this.rate3,
            "market2": this.user1Entity.rate3,
            "market3": this.user2Entity.rate3,
            "market4": this.user3Entity.rate3,
            "sales1": (2.8).toFixed(1),
            "sales2": this.mavg.rate3
          }, {
            "title": "Active Communication",
            "market1": this.rate4,
            "market2": this.user1Entity.rate4,
            "market3": this.user2Entity.rate4,
            "market4": this.user3Entity.rate4,
            "sales1": (3.2).toFixed(1),
            "sales2": this.mavg.rate4
          },
          {
            "title": "Self Regulation",
            "market1": this.rate5,
            "market2": this.user1Entity.rate5,
            "market3": this.user2Entity.rate5,
            "market4": this.user3Entity.rate5,
            "sales1": (3.0).toFixed(1),
            "sales2": this.mavg.rate5
          }, {
            "title": "Reactive",
            "market1": this.rate6,
            "market2": this.user1Entity.rate6,
            "market3": this.user2Entity.rate6,
            "market4": this.user3Entity.rate6,
            "sales1": (1.6).toFixed(1),
            "sales2": this.mavg.rate6
          }, {
            "title": "Contingent",
            "market1": this.rate7,
            "market2": this.user1Entity.rate7,
            "market3": this.user2Entity.rate7,
            "market4": this.user3Entity.rate7,
            "sales1": (2.9).toFixed(1),
            "sales2": this.mavg.rate7
          }, {
            "title": "Solicitation",
            "market1": this.rate8,
            "market2": this.user1Entity.rate8,
            "market3": this.user2Entity.rate8,
            "market4": this.user3Entity.rate8,
            "sales1": (2.7).toFixed(1),
            "sales2": this.mavg.rate8
          }, {
            "title": "Evidential",
            "market1": this.rate9,
            "market2": this.user1Entity.rate9,
            "market3": this.user2Entity.rate9,
            "market4": this.user3Entity.rate9,
            "sales1": (2.4).toFixed(1),
            "sales2": this.mavg.rate9
          }]
      });





      //END FEEDBACK_REPORT_CHART

      setTimeout(() => {
        if ($("body").height() < $(window).height()) {
          $('footer').addClass('footer_fixed');
        } else {
          $('footer').removeClass('footer_fixed');
        }
      }, 1000);
    } else {
      this.router.navigate(['/welcome']);
    }




    $('body').tooltip({
      selector: '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])',
      trigger: 'hover',
      container: 'body'
    }).on('click mousedown mouseup', '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])', function () {
      $('[data-toggle="tooltip"], [title]:not([data-toggle="popover"])').tooltip('destroy');
    });

    checkCookie_eu();

    function checkCookie_eu() {

      var consent = getCookie_eu("cookies_consent");

      if (consent == null || consent == "" || consent == undefined) {
        // show notification bar
        $('#cookie_directive_container').show();
      }

    }

    function setCookie_eu(c_name, value, exdays) {

      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value + "; path=/";

      $('#cookie_directive_container').hide();
    }


    function getCookie_eu(c_name) {
      var i, x, y, ARRcookies = document.cookie.split(";");
      for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
          return unescape(y);
        }
      }
    }



    // new PerfectScrollbar('.scroll_reporttbl');
    // new PerfectScrollbar('.scroll_reporttbl1');

    $('ul.user_dropdown li.dropdown').hover(function () {
      $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
    }, function () {
      $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
    });

  }



  close_cookie() {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + 30);
    var c_value = escape(1) + ((30 == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = "cookies_consent =" + c_value + "; path=/";

    $('#cookie_directive_container').hide();
  }

  anotherFeedback() {
    var ParentId = localStorage.getItem('UserId');
    localStorage.setItem('ParentId', ParentId);
    if (this.MaltiRater == 0) {
      localStorage.setItem('MaltiRater', '1');
    } else {
      localStorage.setItem('MaltiRater', '0');
    }
    window.location.href = '/feedback';
  }


}


// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/feedback-score/feedback-score.component.ts